export default "__VITE_ASSET__iVzOGalK__"